/*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 */

import { Injectable } from '@angular/core';
import { createDialogRoute, InitDialogViewService } from '@gh/common-shared';
import { EntityInputDialogComponent, EntityInputDialogConfig } from '@gh/common-internal-shared';
import { DialogRouteSnapshot } from '@gh/core-ui';
import { WithUniqueId } from '@gh/common-shared-data';
import { ScheduleTaskNoteListItemDto } from './schedule.dto';

export type ScheduleTaskNoteListItem = WithUniqueId<ScheduleTaskNoteListItemDto>;

@Injectable()
export class ScheduleTaskNotesBusinessService
  implements InitDialogViewService<EntityInputDialogConfig<ScheduleTaskNoteListItem>> {
  initDialogView(route: DialogRouteSnapshot<EntityInputDialogConfig<ScheduleTaskNoteListItem>>): any {
    return route.input;
  }
}

export const scheduleTemplateNoteListItemDialog = createDialogRoute(
  {
    component: EntityInputDialogComponent,
    init: ScheduleTaskNotesBusinessService,
  },
);
